import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  FormFieldBase,
  FormFieldOption,
  FormFieldType
} from "../../../../components/dynamic-form-field/components/dynamic-form-light/models/form-field-base";
import {
  FormFieldControlService
} from "../../../../components/dynamic-form-field/components/dynamic-form-light/services/dynamic-form-field-control.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {
  SignDocumentLocalSteps,
  SignDocumentRemoteSteps,
  SignDocumentService
} from "../../services/sign-document.service";
import {DocumentoAllegato} from "../../../../models/documento-allegato";
import {
  SignDocumentConfiguration,
  SignDocumentErrorResponse,
  SignDocumentLocalStartRequest,
  SignDocumentRemoteContinueRequest,
  SignDocumentUploadRequest
} from "../../models/sign-document";
import {map, mergeMap} from "rxjs/operators";
import {Observable} from "rxjs";

export namespace SignDocumentFormFields {
  export const TYPE: FormFieldBase = {
    controlType: FormFieldType[FormFieldType.DROPDOWN],
    key: "sign-document-type",
    label: "Tipo Firma",
    size: "col-sm-6",
    placeholder: "Seleziona una tipologia di firma",
    required: true,
    chips: false
  }
  export const FORMAT: FormFieldBase = {
    controlType: FormFieldType[FormFieldType.DROPDOWN],
    key: "sign-document-format",
    label: "Tipo Formato",
    size: "col-sm-6",
    placeholder: "Seleziona un formato di firma",
    required: true,
    chips: false
  }

  export const ALIAS: FormFieldBase = {
    controlType: FormFieldType[FormFieldType.TEXT],
    key: "sign-document-alias",
    label: "Alias di firma",
    size: "col-sm-6",
    placeholder: "Inserisci l'alias di firma",
    required: true,
    chips: false
  }
}

export enum SignDocumentFormStatus {
  INITIALIZING,
  READY,
  WARN,
  VALIDATING,
  PASSWORD,
  FINALIZING,
  SIGNED,
  ERROR
}

@Component({
  selector: 'app-sign-document-form',
  templateUrl: './sign-document-form.component.html',
  styleUrls: ['./sign-document-form.component.css']
})
export class SignDocumentFormComponent implements OnInit {

  @Input()
  public document: DocumentoAllegato;

  @Output()
  public onSubmit = new EventEmitter<void>();

  protected form: FormGroup;
  protected formFields: FormFieldBase[];
  protected formSignType: FormFieldBase;
  protected formSignFormat: FormFieldBase;

  protected signConfig: SignDocumentConfiguration;
  protected signOtp: string;
  protected signPin: string;
  protected signError: string;
  protected signAlias: string;
  protected status: number;

  constructor(
    private service: SignDocumentService,
    private formFieldControlService: FormFieldControlService
  ) {
    this.service.checkConfigurationPermissions();
  }

  public ngOnInit() {
    this.setStatusAs(SignDocumentFormStatus.INITIALIZING);

    this.initForm();
    this.initConfigurations();

    this.setStatusAs(SignDocumentFormStatus.READY);
  }

  protected initConfigurations() {
    this.service.getConfigurationProperties().subscribe(next => {
      this.signConfig = next;
      this.formSignType.options = this.signConfig.signTypes.map((it): FormFieldOption => ({
        value: it.toLowerCase(),
        label: it
      }));
      this.formSignFormat.options = this.signConfig.signFormats.map((it): FormFieldOption => ({
        value: it.toLowerCase(),
        label: it
      }));
      this.updateForm();
    })
  }

  protected initForm() {
    this.formFields = [];

    this.formFields.push(this.formSignType = {
      ...SignDocumentFormFields.TYPE
    });
    this.formFields.push(this.formSignFormat = {
      ...SignDocumentFormFields.FORMAT
    });

    this.updateForm();
  }

  protected updateForm() {
    this.form = this.formFieldControlService.toFormGroup(this.formFields);
  }

  protected resetForm() {
    this.form.reset();
  }

  protected setStatusAs(status: SignDocumentFormStatus) {
    this.status = status;

    if (this.status === SignDocumentFormStatus.ERROR) {
      return;
    } else if (this.status === SignDocumentFormStatus.SIGNED) {
      this.doSubmit();
    }

    this.signError = undefined;
  }

  protected isStatusAsReady() {
    return this.status === SignDocumentFormStatus.READY;
  }

  protected isStatusAsWarn() {
    return this.status === SignDocumentFormStatus.WARN;
  }

  protected isStatusAsPassword() {
    return this.status === SignDocumentFormStatus.PASSWORD;
  }

  protected isStatusAsSigned() {
    return this.status === SignDocumentFormStatus.SIGNED;
  }

  protected isStatusAsError() {
    return this.status === SignDocumentFormStatus.ERROR;
  }

  protected isSignTypeAsLocal() {
    return this.service.isSignTypeAsLocal(
      this.form.controls[SignDocumentFormFields.TYPE.key].value
    );
  }

  retrieveFormValue(event : { key: string, event: any }){

    if(this.form.get(event.key)){
      this.form.get(event.key).setValue(event.event);
    }
    if(event.key === SignDocumentFormFields.TYPE.key ){

      if(!this.service.isSignTypeAsLocal(event.event)){
       
        if(this.formFields.filter(ff => ff.key === SignDocumentFormFields.ALIAS.key).length === 0){
          this.formFields.push(this.formSignType = {
            ...SignDocumentFormFields.ALIAS
          });
  
          const aliasCtrl = this.formFieldControlService.toFormControl(SignDocumentFormFields.ALIAS);
          this.form.addControl(SignDocumentFormFields.ALIAS.key, aliasCtrl);
        }
            
       
      } else {
        this.formFields = this.formFields.filter(ff => ff.key !== SignDocumentFormFields.ALIAS.key);
        this.form.removeControl(SignDocumentFormFields.ALIAS.key);
      }
      
    }
  }

  protected canNext() {
    switch (this.status) {
      case SignDocumentFormStatus.READY:
        return this.form.valid;
      case SignDocumentFormStatus.PASSWORD:
        if (this.isSignTypeAsLocal()) {
          return this.signPin;
        } else {
          return this.signPin && this.signOtp
        }
    }
    return false;
  }

  protected doNext() {
    if (this.isSignTypeAsLocal()) {
      this.doNextAsLocal();
    } else {
      this.doNextAsRemote();
    }
  }

  private doNextAsLocal() {
    const document = this.document;
    const signFormat = this.form.controls[SignDocumentFormFields.FORMAT.key].value;

    switch (this.status) {
      case SignDocumentFormStatus.READY: {
        this.setStatusAs(SignDocumentFormStatus.WARN);
        return;
      }
      case SignDocumentFormStatus.WARN: {
        this.setStatusAs(SignDocumentFormStatus.PASSWORD);
        return;
      }
      case SignDocumentFormStatus.PASSWORD: {
        this.catchError(
          this.service
            .signDocumentAsLocalCheck(document, signFormat)
            .pipe(
              mergeMap(it =>
                this.service.fetchOriginalDocument(document)
              ),
              mergeMap(it =>
                this.service.signDocumentAsLocalStart(document, signFormat, {
                  format: signFormat,
                  documents: [{
                    id: document.id,
                    content: it
                  }],
                  pin: this.signPin
                })
              ),
              mergeMap(it =>
                this.service.uploadSignedDocument(document, signFormat, {
                  signedFile: {
                    contentSize: it.documents[0].content.length,
                    content: it.documents[0].content
                  },
                  entitaCollegata: document.entitaCollegata
                }).pipe(
                  map(() => it)
                )
              )
            ),
          next => {
            this.setStatusAs(SignDocumentFormStatus.SIGNED);
          }
        );
        return;
      }
    }
  }

  private doNextAsRemote() {
    const document = this.document;
    const signFormat = this.form.controls[SignDocumentFormFields.FORMAT.key].value;
    const alias = this.form.controls[SignDocumentFormFields.ALIAS.key].value;

    switch (this.status) {
      case SignDocumentFormStatus.READY: {
        this.catchError(
          this.service.signDocumentAsRemoteStart(document, signFormat , alias),
          next => {
            this.setStatusAs(SignDocumentFormStatus.PASSWORD);
          }
        );
        break;
      }
      case SignDocumentFormStatus.PASSWORD: {
        this.catchError(
          this.service.signDocumentAsRemoteContinue(document, signFormat, alias , {
            pin: this.signPin,
            otp: this.signOtp
          }),
          next => {
            this.setStatusAs(SignDocumentFormStatus.SIGNED);
          }
        );
        break;
      }
    }
  }

  protected doSetPassword(password: any, isOtp: boolean = false) {
    if (isOtp) {
      this.signOtp = password;
    } else {
      this.signPin = password;
    }
  }

  protected doSubmit() {
    this.onSubmit.emit()
  }

  private catchError<T extends SignDocumentErrorResponse>(observable: Observable<T>, onSubscribe: (next: T) => void) {
    observable.subscribe({
      next: onSubscribe,
      error: (ex: Error) => {
        this.signError = ex.message;
        this.setStatusAs(SignDocumentFormStatus.ERROR);
      }
    });
  }
}
